<template>
  <div>
    <v-alert v-if="!quantidadeAlunos" type="info" outlined dense>
      Informe a quantidade de alunos na aba "Projeção Heppi" para ver a projeção individual.
    </v-alert>

    <template v-else>
      <v-row>
        <v-col v-for="card in cards" :key="card.label" cols="12" sm="6" md="3">
          <v-card outlined class="text-center pa-4 fill-height">
            <div class="caption text--secondary text-uppercase">{{ card.label }}</div>
            <div class="text-h6 font-weight-bold" :class="card.color">{{ card.value | price }}</div>
          </v-card>
        </v-col>
      </v-row>

      <v-card outlined class="mt-4">
        <v-card-title class="subtitle-1 font-weight-bold">Projeção individual por formando</v-card-title>
        <v-data-table
          :headers="headers"
          :items="perStudent"
          no-data-text="Sem dados"
          :footer-props="{ itemsPerPageOptions: [12, 24, 66, -1] }"
          :items-per-page="12"
          dense
        >
          <template v-slot:item.receitaLiquida="{ item }">{{ item.receitaLiquida | price }}</template>
          <template v-slot:item.rendimento="{ item }">{{ item.rendimento | price }}</template>
          <template v-slot:item.saldoAcumulado="{ item }">{{ item.saldoAcumulado | price }}</template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabVisualizacaoFormando',
  props: {
    results: { type: Array, default: () => [] },
    kpis: { type: Object, default: () => ({}) },
    quantidadeAlunos: { type: Number, default: 0 }
  },
  data: () => ({
    headers: [
      { text: 'Mês', value: 'periodLabel' },
      { text: 'Valor líquido / aluno', value: 'receitaLiquida' },
      { text: 'Rendimento / aluno', value: 'rendimento' },
      { text: 'Saldo / aluno', value: 'saldoAcumulado' }
    ]
  }),
  computed: {
    divisor () {
      return this.quantidadeAlunos > 0 ? this.quantidadeAlunos : 1
    },
    cards () {
      const ultimo = this.results.length ? this.results[this.results.length - 1] : {}
      const primeiro = this.results.length ? this.results[0] : {}
      return [
        { label: 'Valor mensal / aluno', value: this.round((primeiro.receitaLiquida || 0) / this.divisor), color: 'primary--text' },
        { label: 'Saldo final / aluno', value: this.round((ultimo.saldoAcumulado || 0) / this.divisor), color: 'primary--text' },
        { label: 'Rendimento bruto / aluno', value: this.round((this.kpis.rendimentoBrutoTotal || 0) / this.divisor), color: 'success--text' },
        { label: 'Ganho líquido estimado', value: this.round((this.kpis.lucroProjetado || 0) / this.divisor), color: 'success--text' }
      ]
    },
    perStudent () {
      return this.results.map(r => ({
        periodLabel: r.periodLabel,
        receitaLiquida: this.round(r.receitaLiquida / this.divisor),
        rendimento: this.round(r.rendimento / this.divisor),
        saldoAcumulado: this.round(r.saldoAcumulado / this.divisor)
      }))
    }
  },
  methods: {
    round (value) {
      return Math.round((value + Number.EPSILON) * 100) / 100
    }
  }
}
</script>
